import Splide from '@splidejs/splide';

const ThumbsSlider = () => {
    const init = () => {
        document.querySelectorAll('section.ia-thumbsslider').forEach(function(section) {
            const selectorPrimary = section.querySelector('.primary .splide');
            const selectorSecondary = section.querySelector('.secondary .splide');

            const primarySlider = new Splide(selectorPrimary, {
                perMove    : 1,
                gap        : '25px',
                type       : 'fade',
                pagination : false,
                arrows     : false,
            });
    
            const secondarySlider = new Splide(selectorSecondary, {
                rewind      : true,
                fixedWidth  : 200,
                fixedHeight : 100,
                isNavigation: true,
                gap         : '25px',
                focus       : 'left',
                pagination  : false,
                cover       : true,
                arrows      : false,
                breakpoints : {
                    '600': {
                        fixedWidth  : 100,
                        fixedHeight : 50,
                    },
                },
            }).mount();
    
            primarySlider.sync(secondarySlider).mount();
    
            primarySlider.on('click', function () {
                secondarySlider.go('+1');
            });
        });
    };

    if ($('section.ia-thumbsslider .primary .splide').length > 0 && $('section.ia-thumbsslider .secondary .splide').length > 0) {
        init();
    }

    /* return ({
        init,
    }); */
}
export default ThumbsSlider;
